import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  Router, RouterModule, NavigationEnd, ActivatedRoute,
} from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { User } from '@angular/fire/auth';

import { AuthService } from '@app/core/services/auth.service';
import { UserMenuComponent } from '@app/shared/user-menu/user-menu.component';

/**
 * App shell header — the chrome for LOGGED-IN, transactional pages
 * (engagements, admin console, checkout). Deliberately NOT the marketing
 * header: no About/Pricing/Community, no offline game — just the Angularize
 * wordmark, a route-derived breadcrumb, and the shared account menu.
 *
 * The breadcrumb reads each route's own `title` (stripping the
 * " | Angularize" suffix), so it stays in sync with routing automatically
 * instead of a hardcoded url→label map that would drift.
 */
@Component({
  selector: 'app-shell-header',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, UserMenuComponent],
  templateUrl: './app-shell-header.html',
  styleUrls: ['./app-shell-header.css'],
})
export class AppShellHeaderComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly auth = inject(AuthService);

  user: User | null = null;
  crumb = '';

  private sub = new Subscription();

  ngOnInit(): void {
    this.sub.add(this.auth.user$.subscribe((u) => (this.user = u)));

    this.sub.add(
      this.router.events
        .pipe(filter((e) => e instanceof NavigationEnd))
        .subscribe(() => this.updateCrumb()),
    );
    this.updateCrumb();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  /** Deepest active route's title, minus the " | Angularize" suffix. */
  private updateCrumb(): void {
    let r = this.route.root;
    let title = '';
    while (r.firstChild) {
      r = r.firstChild;
      const t = r.snapshot.data?.['title'] || r.snapshot.title;
      if (t) title = t;
    }
    this.crumb = (title || '').replace(/\s*\|\s*Angularize\s*$/i, '').trim();
  }

  goHome(): void {
    this.router.navigateByUrl('/');
  }
}